import { render, staticRenderFns } from "./PolygonEditMenu.vue?vue&type=template&id=1dea435e&scoped=true"
import script from "./PolygonEditMenu.vue?vue&type=script&lang=js"
export * from "./PolygonEditMenu.vue?vue&type=script&lang=js"
import style0 from "./PolygonEditMenu.vue?vue&type=style&index=0&id=1dea435e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dea435e",
  null
  
)

export default component.exports